module.exports = __webpack_public_path__ + "static/media/youRock.50db463e.mp3";